import Link from 'next/link';
import { SupportedLanguages } from '@/types/globals';

interface ListViewToggleProps {
  locale: SupportedLanguages;
  basePath: string;
  className?: string;
}

const text = {
  en: {
    listView: 'List View',
    calendarView: 'Calendar View',
    viewEventsInList: 'View events in list format',
  },
  fr: {
    listView: 'Vue Liste',
    calendarView: 'Vue Calendrier',
    viewEventsInList: 'Voir les événements au format liste',
  },
};

export function ListViewToggle({ locale, basePath }: ListViewToggleProps) {
  const translatedText = text[locale];
  // Remove /calendar from the basePath to get back to the list view
  const listPath = `/${basePath}`;

  return (
    <Link
      href={listPath}
      className={`inline-flex items-center gap-2 rounded border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 hover:text-gray-900`}
      title={translatedText.viewEventsInList}
    >
      <svg
        className="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 6h16M4 10h16M4 14h16M4 18h16"
        />
      </svg>
      {translatedText.listView}
    </Link>
  );
}
